import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col h-full"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  style: {"width":"34px","height":"34px"},
  class: "relative"
}
const _hoisted_5 = {
  key: 0,
  style: {"width":"34px","height":"34px"},
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-lg mr-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "ml-auto material-icons text-primary text-base mr-1" }, "auto_awesome", -1)
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center space-x-1 mt-4 flex-wrap"
}
const _hoisted_12 = {
  key: 1,
  class: "opacity-60 text-primary-light font-medium text-lg px-1"
}
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col items-center w-full mx-auto mt-32"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " leaderboard ", -1)
const _hoisted_15 = { class: "opacity-40" }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!

  return (!_ctx.firstLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((_ctx.paginatedUsers?.count ?? 0) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedUsers?.data, (user, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([{ 'bg-gray-50': index % 2, 'opacity-60': _ctx.loading }, "py-3 px-3 w-full flex items-center h-full"]),
                    key: 'leaderboard-user-' + index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["mr-2", {
							'text-yellow-400': _ctx.pageNumber === 1 && index === 0,
							'text-gray-400': _ctx.pageNumber === 1 && index === 1,
							'text-bronze': _ctx.pageNumber === 1 && index === 2,
							'opacity-0': _ctx.loading,
						}])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        (_ctx.pageNumber === 1 && index < 3)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", {
                          class: _normalizeClass([{
									'font-medium opacity-90 text-sm drop-shadow-lg filter':
										_ctx.pageNumber === 1 && index < 3,
									'text-yellow-800': _ctx.pageNumber === 1 && index === 0,
									'text-gray-900': _ctx.pageNumber === 1 && index === 1,
									'text-yellow-900': _ctx.pageNumber === 1 && index === 2,
								}, "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-muted opacity-50"])
                        }, _toDisplayString(_ctx.getUserPosition(user.id)), 3)
                      ])
                    ], 2),
                    _createVNode(_component_Avatar, {
                      size: 'lg',
                      class: "mr-4 ml-4",
                      user: user
                    }, null, 8, ["user"]),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(user.full_name), 1),
                    _hoisted_9,
                    _createElementVNode("p", _hoisted_10, _toDisplayString(user.reputation), 1)
                  ], 2))
                }), 128))
              ]),
              (_ctx.lastPageNumber > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (page) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'page-btn-' + page
                      }, [
                        (page !== _ctx.pageNumber)
                          ? (_openBlock(), _createBlock(_component_Btn, {
                              key: 0,
                              size: 'xs',
                              onClick: ($event: any) => (_ctx.pageNumber = page),
                              variant: 'primary-borderless'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(page), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(page), 1))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t("gamification.no_leaderboard")), 1)
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createVNode(_component_SlotSkeleton),
        _createVNode(_component_SlotSkeleton),
        _createVNode(_component_SlotSkeleton)
      ]))
}